<template>
  <metainfo>
    <template v-slot:title="{ content }">
      {{ content }}
    </template>
  </metainfo>

  <visitor-identification />
  <div class="container">
    <div class="flex flex-row justify-between items-center w-full">
      <a href="#" id="menu" class="block" @click.prevent="menuClick"></a>
      <a href="/goodcalldartsclub/" class="block text-center">
        <div v-if="route.name === 'home'" class="home-img logo py-10"><span></span></div>

        <img
          v-else
          src="./assets/good-call-logo.png"
          alt="Good Call Darts Club"
          class="logo py-10"
        />
      </a>
      <div>
        <a href="/goodcalldartsclub/">
          <img
            v-if="route.name !== 'home'"
            src="./assets/pdc-fosters.png"
            alt="PDC x Fosters"
            class="pdc-logo"
          />
        </a>
      </div>
    </div>

    <placeholder name="jss-main" :rendering="route" />
  </div>

  <site-footer />

  <div id="overlay_menu" @click="overlayClick">
    <div class="overlay_menu_list">
      <ul>
        <li>
          <a
            href="/goodcalldartsclub/world-darts-championship"
            :class="{ active: currentUrl === '/world-darts-championship' }"
            ><span class="icon"></span><span class="text">Win: Tickets to the WDC</span></a
          >
        </li>
        <li>
          <a
            href="/goodcalldartsclub/darts-premier-league"
            :class="{ active: currentUrl === '/darts-premier-league' }"
            ><span class="icon"></span><span class="text">Win: Darts Premier League</span></a
          >
        </li>

        <li class="calculator">
          <a
            href="/goodcalldartsclub/darts-scorer"
            :class="{ active: currentUrl === '/darts-scorer' }"
            ><span class="icon"></span><span class="text">Darts Scorer</span></a
          >
        </li>
        <!--<li class="mapicon">
        <a href="/pub-finder" :class="{ active: currentUrl === '/pub-finder' }"><span class="icon"></span><span class="text">Pub Finder</span></a>
    </li>-->
        <li class="downunder">
          <a
            href="/goodcalldartsclub/down-under-darts-games"
            :class="{ active: currentUrl === '/down-under-darts-games' }"
            ><span class="icon"></span><span class="text">Down Under Games</span></a
          >
        </li>
        <li class="darts">
          <a href="/goodcalldartsclub/darts-101" :class="{ active: currentUrl === '/darts-101' }"
            ><span class="icon"></span><span class="text">Darts 101</span></a
          >
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { defineComponent, onMounted, onUnmounted } from 'vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import VisitorIdentification from './VisitorIdentification';
import { useMeta } from 'vue-meta';
import './assets/app.css';
import SiteFooter from './SiteFooter.vue';
import { gtmEvent } from './utils/analytics';

export default defineComponent({
  name: 'Layout',
  props: {
    route: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    useMeta({
      title:
        (props.route.fields &&
          props.route.fields.pageTitle &&
          props.route.fields.pageTitle.value) ||
        'Page',
    });

    // gtmEvent('page_view', {
    //   page_title: props?.route?.fields?.pageTitle?.value,
    // });

    const route = useRoute();
    const currentUrl = computed(() => route.fullPath);

    function menuClick(event) {
      if (event && event.preventDefault) event.preventDefault();

      const menuBtn = document.getElementById('menu');
      if (menuBtn) {
        menuBtn.classList.toggle('open');
      }

      const overlay = document.getElementById('overlay_menu');
      if (overlay) {
        overlay.classList.toggle('open');
      }

      const body = document.body || document.getElementsByTagName('body')[0];
      if (body) {
        body.classList.toggle('menu');
      }

      gtmEvent('menu_open', {
        menu_name: 'main_navigation',
      });
    }

    function handleScroll() {
      const scrolled =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const body = document.body || document.getElementsByTagName('body')[0];
      if (body) {
        if (scrolled > 0) {
          body.classList.add('scroll');
        } else {
          body.classList.remove('scroll');
        }
      }
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    function overlayClick(event) {
      const body = document.body || document.getElementsByTagName('body')[0];

      if (!body || !body.classList.contains('menu')) return;

      const clickedInside =
        event &&
        event.target &&
        event.target.closest &&
        event.target.closest('.overlay_menu_list ul');
      if (clickedInside) return;

      const overlay = document.getElementById('overlay_menu');
      if (overlay) {
        overlay.classList.remove('open');
      }

      const menuBtn = document.getElementById('menu');
      if (menuBtn) {
        menuBtn.classList.remove('open');
      }

      if (body) {
        body.classList.remove('menu');
      }

      gtmEvent('menu_close', {
        menu_name: 'main_navigation',
      });
    }

    return {
      menuClick,
      overlayClick,
      currentUrl,
    };
  },
  components: {
    Placeholder,
    VisitorIdentification,
    SiteFooter,
  },
});
</script>
